import type { UseMutationOptions } from "react-query";
import { useMutation } from "react-query";
import { authenticationAppRoutes } from "@circle-react/components/OnboardingPage/helpers/routes";
import { reactQueryPost } from "@circle-react/helpers/backendRequestHelpers";
import { useToast } from "@circle-react-uikit/ToastV2";

interface ResendOtpResult {
  message: string;
}
interface ResendOtpProps {
  options?: UseMutationOptions<any, unknown, any, unknown>;
}

interface RequestBody {
  user: {
    email: string;
  };
}

export const useResendOtp = ({ options = {} }: ResendOtpProps) => {
  const toast = useToast();

  return useMutation(
    (body: RequestBody) =>
      reactQueryPost(authenticationAppRoutes.resendOtp(), body),
    {
      onSuccess: (data: ResendOtpResult) => {
        toast.success(data?.message);
      },
      onError: (error: any) => {
        console.error(error);
        toast.error(error.body?.error || error.message);
      },
      ...options,
    },
  );
};
